import { ColorFormat } from '../../../../../../types'
import { capitalize } from '@sketch/utils'
import copyGradient from '../../../components/GradientAttribute/copy'
import { rgbTo } from '../../../components/Color/utils'
import { Border, FillType } from '../../../../../../../inspector'

const isBlendModeVisible = (blendMode: string) =>
  blendMode.toUpperCase() !== 'NORMAL'

export const getBorderWidthCopyValue = ({
  thickness,
  sidesThickness,
}: Pick<Border, 'thickness' | 'sidesThickness'>) => {
  if (!sidesThickness) {
    return `${thickness}px`
  }

  const nonZeroSides = [
    sidesThickness.left,
    sidesThickness.top,
    sidesThickness.right,
    sidesThickness.bottom,
  ].filter(value => value !== 0)

  if (nonZeroSides.length === 1) {
    return `${nonZeroSides[0]}px`
  }

  return `${sidesThickness.top}px ${sidesThickness.right}px ${sidesThickness.bottom}px ${sidesThickness.left}px`
}

const borderCopyValue = (
  {
    isEnabled,
    fillType,
    gradient,
    color,
    position,
    thickness,
    sidesThickness,
    appearance,
  }: Border,
  colorFormat: ColorFormat
) => {
  if (!isEnabled) {
    return null
  }

  let copyValue = ``

  if (fillType === FillType.Color && color) {
    copyValue += `Color: ${rgbTo(colorFormat, color)}`
  } else if (fillType === FillType.Gradient && gradient) {
    copyValue += copyGradient(gradient, appearance, colorFormat)
  }

  const blendMode = appearance && appearance.blendMode
  if (isBlendModeVisible(blendMode)) {
    copyValue += `\nBlend Mode: ${capitalize(blendMode)}`
  }
  if (position) {
    copyValue += `\nPosition: ${position}`
  }

  copyValue += `\nWidth: ${getBorderWidthCopyValue({
    thickness,
    sidesThickness,
  })}`

  copyValue += `\n\n`

  return copyValue
}

const copy = (
  borders: Border[],
  colorFormat: ColorFormat = ColorFormat.HEX
) => {
  let sectionCopyValue = ``
  borders.forEach((border, index) => {
    const copyValue = borderCopyValue(border, colorFormat)
    if (copyValue) {
      sectionCopyValue += `Border ${index}\n`
      sectionCopyValue += copyValue
    }
  })
  return sectionCopyValue
}

export default copy
